import { createApp, watch } from 'vue';
import App from './App.vue';
import './style.css';

import { createPinia } from 'pinia';
import { createRouter, createWebHistory } from 'vue-router';
import NaiveUI from 'naive-ui';

import routes from './router';
import { setupRouterGuards } from './router/guards';
import { setupConsentGuard } from './router/consentGuard';
import { useCookieConsent } from './composables/useCookieConsent';
import { initAnalytics } from './analytics';

// Load cookie consent before initializing the app
const cookieConsent = useCookieConsent();
cookieConsent.loadConsent();

// Track consent changes and manage third-party scripts
watch(cookieConsent.consent, (newConsent) => {
    // Manage analytics scripts based on consent
    if (newConsent === 'all') {
        cookieConsent.enableAnalytics();
    } else {
        cookieConsent.disableAnalytics();
    }
});

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, _from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }

        if (to.hash) {
            return {
                el: to.hash,
                top: 90,
                behavior: 'smooth',
            };
        }

        return { top: 0 };
    },
});
// Register navigation guards
setupRouterGuards(router);
// Register route guard for consent checking
setupConsentGuard(router);

app.use(router);
app.use(NaiveUI);
app.mount('#app');

// Initialize analytics after app mounting
initAnalytics();